<template>
    <div class="table-wraper">
        <!-- <div class="sticky-caption">
            <h3 class="mdi mdi-pill">
                Medicamento buscado: {{ selected_medication.marca }},
                {{ selected_medication.descripcion }}
            </h3>
        </div> -->
        <table class="product-table">
            <thead>
                <tr>
                    <th class="celltitle"></th>
                    <th
                        v-for="presentation in sortedPresentations"
                        :key="presentation"
                        class="th-header">
                        <div class="button blue">
                            {{ presentation }}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="medication in sortedMedications"
                    :key="medication.brand">
                    <th class="brand">{{ medication.brand }}</th>
                    <td
                        @click="select_medication"
                        v-for="presentation in sortedPresentations"
                        :key="presentation"
                        :class="{
                            disabled: !getPrice(
                                medication.presentations,
                                presentation,
                            ).price,
                        }"
                        :id="
                            Array.isArray(
                                getPrice(medication.presentations, presentation)
                                    .id,
                            )
                                ? getPrice(
                                      medication.presentations,
                                      presentation,
                                  ).id[0]
                                : getPrice(
                                      medication.presentations,
                                      presentation,
                                  ).id
                        ">
                        <v-row
                            class="pzs-container"
                            v-if="
                                getPrice(medication.presentations, presentation)
                                    .price
                            ">
                            <span
                                v-if="
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).total_existencia
                                "
                                class="pzs-label label"
                                @click.stop="
                                    openDialog(
                                        getPrice(
                                            medication.presentations,
                                            presentation,
                                        ),
                                    )
                                "
                                >Existencias:
                                {{
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).total_existencia
                                }}
                            </span>
                            <span
                                class="unavailible-label label"
                                v-if="
                                    !getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).availability &&
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).availible_in_any_branch
                                "
                                @click.stop="
                                    openDialog(
                                        getPrice(
                                            medication.presentations,
                                            presentation,
                                        ),
                                    )
                                "
                                >Disponible en otras sucursales
                            </span>
                        </v-row>
                        <v-dialog
                            v-model="showDialog"
                            v-if="
                                selectedPresentation?.id ===
                                getPrice(medication.presentations, presentation)
                                    .id
                            ">
                            <notificationDialog
                                :presentation="
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    )
                                "
                                :selectedPresentation="selectedPresentation"
                                :locationId="locationId"
                                :locations="locations"
                                @closeDialog="dialogo = false"
                                @close="closeDialog"
                                @click:outside="
                                    closeDialog
                                "></notificationDialog>
                        </v-dialog>
                        <span
                            v-if="
                                getPrice(medication.presentations, presentation)
                                    .price
                            "
                            :class="{
                                unavailible: !getPrice(
                                    medication.presentations,
                                    presentation,
                                ).availability,
                            }">
                            ${{
                                getPrice(
                                    medication.presentations,
                                    presentation,
                                ).price.toFixed(2)
                            }}
                            <span class="price-by-piece">
                                ${{
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    )['price_per_unit'].toFixed(2)
                                }}/unidad</span
                            >
                        </span>
                        <div
                            v-if="
                                getPrice(medication.presentations, presentation)
                                    .price
                            "
                            class="label-container">
                            <span
                                class="promotion-label label"
                                v-if="
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).promotion
                                "
                                :title="
                                    getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).promotion.ruleDescription
                                "
                                >Promocion de pastillero</span
                            >
                            <span
                                class="label unexistent-label"
                                v-if="
                                    !getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).availability &&
                                    !getPrice(
                                        medication.presentations,
                                        presentation,
                                    ).availible_in_any_branch
                                "
                                >Desabasto general</span
                            >
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import confetti from 'canvas-confetti';
import notificationDialog from '@/components/global/notification-dialog.vue';
export default {
    components: {
        notificationDialog,
    },
    emits: ['select-medication', 'order-by-presentation-price'],
    props: {
        selected_medication: null,
        medicationData: Object,
        presentations: {
            type: Array,
            required: true,
        },
        medications: {
            type: Array,
            required: true,
        },
        locations: {
            type: Array,
            default: () => [],
        },
        locationId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            counter: 0,
            showDialog: false,
            selectedPresentation: null,
        };
    },
    computed: {
        // sortedBrands() {
        //     return [...(this.medicationData?.grouped_medications || [])].sort(
        //         (a, b) => a.brand.localeCompare(b.brand),
        //     );
        // },
        // sortedPresentations() {
        //     return [...(this.medicationData?.all_presentations || [])].sort(
        //         (a, b) => {
        //             const numA = parseInt(a.match(/\d+/)?.[0] || 0);
        //             const numB = parseInt(b.match(/\d+/)?.[0] || 0);
        //             return numA - numB;
        //         },
        //     );
        // },
        searchedPresentation() {
            if (!this.selected_medication?.barcode) return null;
            for (const med of this.medications) {
                const presentation = med.presentations.find((p) => {
                    if (Array.isArray(p.id)) {
                        return p.id.includes(this.selected_medication.barcode);
                    }
                    return p.id === this.selected_medication.barcode;
                });
                if (presentation) {
                    return {
                        brand: med.brand,
                        presentation: presentation.name,
                    };
                }
            }
            return null;
        },
        sortedMedications() {
            return [...this.medications].sort((a, b) =>
                a.brand.localeCompare(b.brand),
            );
        },
        sortedPresentations() {
            return [...this.presentations].sort((a, b) => {
                const getParts = (str) => {
                    const match = str.match(/^(\d+)\s*(.*)/);
                    return [parseInt(match[1]), match[2].trim()];
                };

                const [numA, textA] = getParts(a);
                const [numB, textB] = getParts(b);

                if (numA !== numB) return numA - numB;

                return textA.localeCompare(textB);
            });
        },
    },
    mounted() {
        this.alignPresentations(
            this.sortedMedications,
            this.sortedPresentations,
        );
    },
    watch: {
        medications: {
            handler(newVal) {
                this.alignPresentations(newVal, this.presentations);
            },
            deep: true,
        },
    },
    methods: {
        getPresentation(brand, presentationName) {
            return brand.presentations.find((p) => p.name === presentationName);
        },
        formatId(id) {
            return Array.isArray(id) ? id.join(', ') : id;
        },
        getPrice(medications, presentation) {
            const medication = medications.find(
                (medication) => medication.name === presentation,
            );
            return medication || { price: null };
        },
        alignPresentations(medications, presentations) {
            medications.forEach((medication) => {
                presentations.forEach((presentation, i) => {
                    const existingPresentation = medication.presentations.find(
                        (p) => p.name === presentation,
                    );
                    if (!existingPresentation) {
                        medication.presentations.splice(i, 0, {
                            name: presentation,
                            price: null,
                        });
                    }
                });

                medication.presentations.sort((a, b) => {
                    const indexA = presentations.indexOf(a.name);
                    const indexB = presentations.indexOf(b.name);
                    return indexA - indexB;
                });
            });
        },
        /**
         * @param {KeyboardEvent} event
         */
        select_medication(event) {
            const td = event.target.closest('td');

            if (!td) return;

            if (td.classList.contains('disabled')) {
                this.counter += 1;
                if (this.counter >= 30) {
                    this.counter = 0;
                    this.displayConfetti();
                }
                return;
            }

            this.counter = 0;

            const previouslySelected = document.querySelector('.selected');
            if (previouslySelected) {
                previouslySelected.classList.remove('selected');
            }

            td.classList.add('selected');
            this.$emit('select-medication', td.id);
        },
        displayConfetti() {
            confetti({
                particleCount: 200,
                spread: 160,
                origin: { y: 0.6 },
            });
            const audio = new Audio(
                'https://www.myinstants.com/media/sounds/yippee-tbh.mp3',
            );
            audio.play();
        },
        isSearched(currentBrand, currentPresentation) {
            if (!this.searchedPresentation) return false;
            return (
                currentBrand === this.searchedPresentation.brand ||
                currentPresentation.name ===
                    this.searchedPresentation.presentation
            );
        },
        openDialog(presentation) {
            this.selectedPresentation = presentation;
            this.showDialog = true;
        },
        closeDialog() {
            this.showDialog = false;
        },
    },
};
</script>
<style scoped>
table {
    width: 100%;
    position: relative;
    z-index: 1;
    background: white;
    border-collapse: separate;
    border-spacing: 10px 5px;
}

.table-wraper {
    overflow-x: auto;
    margin-top: 1rem;
    max-height: 40vh;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    background-color: white;
    position: relative;
    z-index: 1;
    overflow-y: auto;
}

.sticky-caption {
    position: sticky;
    left: 0;
    z-index: 10;
    background: white;
    display: inline-block;
    min-width: 100%;
    color: white;
    background-color: var(--celeste-electrico);
    position: sticky;
    top: 0;
    z-index: 2;
}

.sticky-caption h3 {
    margin: 0;
    padding: 4px 4px;
    display: inline-block;
    background: inherit;
    white-space: nowrap;
}

table caption {
    position: sticky;
    top: 0;
    z-index: 2;
    color: white;
    background-color: var(--celeste-electrico);
}

table thead,
table thead th {
    position: sticky;
    top: 0px;
    z-index: 2;
}

.th-header {
    align-items: center;
    padding-bottom: 5px;
}

.button {
    padding: 8px 16px;
    font-weight: 600;
    font-size: 0.9rem;
    color: #fff;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
    background-color: var(--aguamarina-tropical);
    min-width: 98px;
}

table tbody th {
    position: sticky;
    left: 0;
    z-index: 1;
}

table thead th.celltitle {
    position: sticky;
    left: 0;
    z-index: 3;
}

table tbody th,
table thead th.celltitle {
    color: white;
    background-color: rgba(48, 177, 228, 1);
}

th.brand {
    text-align: left;
}

table tbody th {
    min-width: max-content;
    min-height: max-content;
    border: 1px solid #ddd;
    padding: 6px;
    text-align: center;
}

table td {
    padding: 10px;
    min-width: max-content;
    min-height: max-content;
    text-align: center;
    position: relative;
    background-color: white;
    border: 1px solid var(--celeste-electrico);
}

td:active {
    background-color: #45454549;
    color: white;
    cursor: pointer;
    outline: 2px solid white;
    outline-offset: -2px;

    .label {
        color: white;
    }

    .label::before {
        color: white;
    }
}

td:hover {
    background-color: rgba(35, 35, 35, 0.157); /* hover */
    color: white;
    cursor: pointer;
    outline: 2px solid white;
    outline-offset: -2px;

    .label {
        color: white;
    }

    .label::before {
        color: white;
    }
}

.disabled {
    background: repeating-linear-gradient(
        45deg,
        #e0e0e0,
        #e0e0e0 10px,
        #f5f5f5 10px,
        #f5f5f5 20px
    );
}

.disabled::before {
    content: 'No disponible';
    position: absolute;
    top: 50%;
    left: 50%;
    color: #555;
    transform: translate(-50%, -50%);
    font-weight: bold;
}

.disabled:hover {
    cursor: not-allowed;
    color: black;
    border: 1px solid #000000c2;
}

.unavailible {
    /* TODO: Cambiar color a uno mas bonito */
    color: grey;
}

.label-container {
    align-self: last baseline;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
    bottom: 0;
    left: 0;
    text-align: left;
    line-height: 1;
    min-width: max-content;
}

.label {
    font-size: 0.8rem;
    margin-left: 0.5rem;
    border-radius: 10px;
    font-weight: bold;
}

.label::before {
    content: '●';
}

.promotion-label {
    background-color: #007bff22;
    color: var(--celeste-electrico);
}

.promotion-label::before {
    color: #007bff;
}

.unavailible-label {
    background-color: #61616138;
    color: grey;
}

.unavailible-label::before {
    color: grey;
}

.unexistent-label {
    background-color: #ffc0c0;
    color: red;
}

.unexistent-label::before {
    color: red;
}

.rotated-icon {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

.pzs-label {
    background-color: var(--aguamarina-tropical);
    color: white;
    padding: 2px;
}

.pzs-container {
    align-self: last baseline;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.1rem;
    bottom: 0;
    left: 0;
    text-align: left;
    line-height: 1;
    min-width: max-content;
    margin: 1px;
}

.searched {
    background: rgba(74, 173, 254, 0.15); /* cruz */
}

.searched::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.selected-line {
    background-color: #303fe3;
}

.selected-line-cell {
    background-color: #8c93e5;
}

.selected {
    background: rgb(86, 222, 199); /* selected */
    color: white;
    cursor: pointer;
    outline: 2px solid white;
    outline-offset: -2px;

    .label {
        color: white;
    }

    .label::before {
        color: white;
    }
}

.price-by-piece {
    font-size: 0.8rem;
    color: grey;
    transform: translate(0, -0.5rem);
}
</style>
